import React, { useState } from 'react';
import { FaEdit, FaTrash, FaPlus,FaSearch } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import '../Styles/UserTypes.css';
import '../Styles/PopupModal.css';
import { useSidebar } from '../Layout/SidebarContext';

const Organization = () => {
  const { isConfigOpen } = useSidebar();

  const [organizations, setOrganizations] = useState([
    {
      id: 1,
      name: 'Neviton',
      createdBy: 'Mohan',
      createdDate: '15-Mar-2021',
      editedBy: 'Ameena',
      editedDate: '13-Jun-2024',
    },
    {
      id: 2,
      name: 'Strides',
      createdBy: 'Ananya',
      createdDate: '12-Jan-2022',
      editedBy: 'Chandini',
      editedDate: '10-Jun-2024',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newOrganization, setNewOrganization] = useState('');

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editOrganization, setEditOrganization] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleAddNew = () => setIsModalOpen(true);

  const handleModalClose = () => {
    setNewOrganization('');
    setIsModalOpen(false);
  };

  const handleSaveNew = () => {
    if (newOrganization.trim()) {
      const newOrg = {
        id: organizations.length + 1,
        name: newOrganization,
        createdBy: 'Admin',
        createdDate: new Date().toLocaleDateString(),
        editedBy: 'Admin',
        editedDate: new Date().toLocaleDateString(),
      };

      setOrganizations([...organizations, newOrg]);
      setNewOrganization('');
      setIsModalOpen(false);
    }
  };

  const handleEditOrganization = (index) => {
    const organization = organizations[index];
    setEditOrganization(organization.name);
    setEditIndex(index);
    setEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    const updatedOrganizations = [...organizations];
    updatedOrganizations[editIndex] = {
      ...updatedOrganizations[editIndex],
      name: editOrganization,
      editedBy: 'Admin',
      editedDate: new Date().toLocaleDateString(),
    };

    setOrganizations(updatedOrganizations);
    setEditModalOpen(false);
  };

  const handleDeleteOrganization = (index) => {
    setDeleteIndex(index);
    setConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    const updatedOrganizations = organizations.filter((_, index) => index !== deleteIndex);
    setOrganizations(updatedOrganizations);
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const handleCancelDelete = () => {
    setConfirmDelete(false);
    setDeleteIndex(null);
  };

  const filteredOrganizations = organizations.filter((org) =>
    org.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`user-types-container ${isConfigOpen ? 'shifted-right' : ''}`}>
      <div className="heading">
        <h2>Manage Organizations</h2>
        <div className="search-container">
          <input
            type="text"
            placeholder="Search Organizations"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <table className="user-types-table">
        <thead>
          <tr>
            <th>
              <MdAdd size={24} color="#1e3c72" onClick={handleAddNew} />
            </th>
            <th>Organization</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Edited By</th>
            <th>Edited Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrganizations.map((organization, index) => (
            <tr key={organization.id}>
              <td>
                <FaEdit
                  size={15}
                  style={{ cursor: 'pointer', color: '#00bfa5' }}
                  onClick={() => handleEditOrganization(index)}
                />
                <FaTrash
                  size={15}
                  color="#f44336"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDeleteOrganization(index)}
                />
              </td>
              <td>{organization.name}</td>
              <td>{organization.createdBy}</td>
              <td>{organization.createdDate}</td>
              <td>{organization.editedBy}</td>
              <td>{organization.editedDate}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Add Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Organization</h3>
              <input
                placeholder='Enter Organization Name'
                type="text"
                value={newOrganization}
                onChange={(e) => setNewOrganization(e.target.value)}
              />
            <div className="modal-actions">
              <button onClick={handleSaveNew}>Save</button>
              <button onClick={handleModalClose}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Organization</h3>
              <input
                type="text"
                value={editOrganization}
                onChange={(e) => setEditOrganization(e.target.value)}
              />
            <div className="modal-actions">
              <button onClick={handleSaveEdit}>Save</button>
              <button onClick={() => setEditModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation */}
      {confirmDelete && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Are you sure you want to delete this organization?</h3>
            <div className="modal-actions">
              <button onClick={handleConfirmDelete}>Yes, Delete</button>
              <button onClick={handleCancelDelete}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Organization;
